const React = require("react");
const {Box} = require("@material-ui/core");

const {TableMerchant} = require("../../../../../../../helpers/Table");
const {openPopupInfo} = require("../../../../../../../../emitters/popup");
const {
  DisplayAddressMerchant,
} = require("../../../../../../../helpers/Display/DataDisplay");
const {apiV2StableCoinAccountList} = require("../../../../../../../../api/merchant/stablecoin");
const {bankAccountId$, accountType$} = require("../state");
const openPopupDeleteStableCoinAccount = require("./openPopupDeleteStableCoinAccount");

const getRowsFromServer = ({offset, limit}) => {
  return apiV2StableCoinAccountList({offset, limit});
};

module.exports = () => {
  return (
    <>
      <Box width="100%" height="calc(100vh - 350px)" minHeight="500px" mt="2rem">
        <TableMerchant
          getDataFromServer={getRowsFromServer}
          columns={[
            {
              minWidth: 300,
              label: 'Address',
              dataKey: 'address',
              dataHandler: ({address}) => (
                <DisplayAddressMerchant>
                  {address}
                </DisplayAddressMerchant>
              )
            },
            {
              minWidth: 300,
              label: 'Address Tag',
              dataKey: 'address_tag',
              dataHandler: ({address_tag}) => (
                <DisplayAddressMerchant>
                  {address_tag}
                </DisplayAddressMerchant>
              )
            },
            {
              minWidth: 300,
              label: 'Currency',
              dataKey: 'asset_code'
            },
            {
              minWidth: 300,
              label: 'Status',
              dataKey: 'primary',
              dataHandler: ({primary}) => (
                <div
                  className={
                    `cFFBF43 c2CE889.primary`
                    + (primary ? ' primary' : '')
                  }
                >
                  {primary ? 'Primary' : 'Secondary'}
                </div>
              )
            }
          ]}
          actions={(data, update) => ([
            {
              name: 'Edit',
              onClick() {
                bankAccountId$.emit(data.id);
                accountType$.emit('stablecoinAccounts');
              }
            },
            {
              name: 'Delete',
              onClick() {
                if (data.primary) {
                  const msg = (<div>
                    <p>Company should have at least one stablecoin account marked as &quot;Primary&quot;</p>
                    <p>Set/Add another stablecoin account as &quot;primary&quot; and try again.</p>
                  </div>);
                  openPopupInfo(['Error', msg]);
                  return;
                }
                openPopupDeleteStableCoinAccount(data, update);
              }
            },
          ])}
          disableFilters
        />
      </Box>
    </>
  )
}
